import { render, staticRenderFns } from "./layout-page.vue?vue&type=template&id=f2db9b34&scoped=true&lang=pug"
import script from "./layout-page.vue?vue&type=script&lang=js"
export * from "./layout-page.vue?vue&type=script&lang=js"
import style0 from "./layout-page.vue?vue&type=style&index=0&id=f2db9b34&prod&lang=less&scoped=true"
import style1 from "./layout-page.vue?vue&type=style&index=1&id=f2db9b34&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2db9b34",
  null
  
)

export default component.exports